// DEPRECATED
import glmatrix from '../glmatrix';

export default glmatrix;
